import { render, staticRenderFns } from "./team.vue?vue&type=template&id=555d760b&scoped=true"
import script from "./team.vue?vue&type=script&lang=ts"
export * from "./team.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "555d760b",
  null
  
)

export default component.exports